import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
//import api_base_url from "../../config";
import axiosInstance from "../../../../api/axiosInstance";

const initialState = {
  jobs: [],
  status: 'idle', // can be 'idle', 'loading', 'succeeded' or 'failed'
  error: null,
};

export const fetchCompletedJobs = createAsyncThunk(
  'completedJobs/fetchCompletedJobs',
  async ({ userId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/Jobs/GetJobs`, {
        params: { UserId: userId, Status: 'Completed' },
        headers: {
         // Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch(endUserSession());
      }
      return rejectWithValue(
        error.response?.data || 'Failed to fetch completed jobs'
      );
    }
  }
);
const completedJobsSlice = createSlice({
  name: 'completedJobs',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompletedJobs.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchCompletedJobs.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.jobs = action.payload;
      })
      .addCase(fetchCompletedJobs.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
        state.jobs = [];
      });
  },
});

export default completedJobsSlice.reducer;
